import { Text, View, StyleSheet } from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
    row: {
        marginTop: 100,
        flexGrow: 1,
        flexDirection: 'row',
    },
    leftcol: {
        width: '50%',
        flexGrow: 1,
        flexDirection: 'column',
    },
    rightcol: {
        width: '50%',
        flexGrow: 1,
        flexDirection: 'column',
    },
    col: {
        // flexGrow: 1,
        flexDirection: 'column',
    },
});

const FooterRowR = () => {
    return (
        <View style={styles.row}>
            <View style={styles.leftcol}></View>
            <View style={styles.rightcol}>
                <Text>For and on behalf of</Text>
                <Text>MEDICAL BROTHERS LIMITED</Text>
                <Text style={{ paddingTop: 50 }}></Text>
                <Text>Authorized Signature & Compay chop</Text>
            </View>
        </View>
    )
}
export default FooterRowR